export const handleApiError = (error: any, rejectWithValue: any, defaultMessage: string) => {

  if (
    error?.message === "canceled" ||
    error?.message === "Request cancelled" ||
    error?.code === "ECONNABORTED"
  ) {
    return rejectWithValue("Request cancelled");
  }

  const detailsMessage = Array.isArray(error?.response?.data?.details)
    ? error.response.data.details.find((detail: any) => typeof detail?.message === 'string')?.message
    : undefined;

  const errorMessage =
    detailsMessage ??
    error?.response?.data?.message ??
    error?.response?.data?.error ??
    error?.response?.data?.detail ??
    error?.response?.statusText ??
    error?.message ??
    defaultMessage;

  // Custom handling for Oracle integrity constraint error.
  // The API may surface this as 'ORA-02292' or as a plain 'integrity constraint' message,
  // so we match both patterns and route to the correct UI message by endpoint.
  const isIntegrityError =
    typeof errorMessage === 'string' &&
    (errorMessage.includes('ORA-02292') || errorMessage.toLowerCase().includes('integrity constraint'));

  if (isIntegrityError) {
    const requestUrl: string = error?.config?.url ?? '';
    const requestMethod: string = (error?.config?.method ?? '').toUpperCase();
    if (requestMethod === 'DELETE') {
      if (requestUrl.includes('/ubt/project/team')) {
        return rejectWithValue(
          'This team cannot be deleted because it has team documents associated with it.'
        );
      } else if (requestUrl.includes('/ubt/project')) {
        return rejectWithValue(
          'In order to delete this project, you must first delete all team documents associated with it.'
        );
      } else {
        // Fallback for unknown endpoints
        return rejectWithValue(
          'An integrity constraint violation occurred. Please ensure there are no dependent records before attempting to delete.'
        );
      }
    } else {
      // For non-DELETE requests, show a generic error banner
      return rejectWithValue('Something went wrong');
    }
  }

  return rejectWithValue(errorMessage);
};
